export default "__VITE_ASSET__CC3v4lTV__"